import { AccountPage } from "@/types/account"
import { QueryInItInfoResponse, WebsiteInfoState } from "@/types/websiteInfo"

export const useWebsiteInfoStore = defineStore("websiteInfo", () => {
  const isRouterAlive = ref(true)
  const websiteErrorStatus = ref<"SystemMaintenance" | "IPBlock" | null>(null)
  const websiteErrorMessage = ref("")
  const state = reactive<WebsiteInfoState>({
    JblName: "",
    accountPage: {
      accountName: "",
      accountTimeZone: "",
      titleName: "",
      labelList: [],
      hasLogout: false,
      logoutWording: "",
      isDemoAccounts: false
    },
    apiLogoutUrl: "",
    bannerSettingUrl: "",
    betfairCurrencyMaxOdds: 1.01,
    betfairCurrencyMinOdds: 1.01,
    bettingOddsLength: 0,
    bettingStakeLength: 0,
    coinPreference: "",
    country: "",
    currencySymbol: "",
    customizeStake: null,
    dC: [],
    timeZone: "",
    enableAsianhandicapForecastDesc: false,
    enableBetfairBookMode: false,
    enableCustomizeStake: false,
    enableGliveStreaming: false,
    enableH2HButton: false,
    enableJblCollectPlayerInfo: false,
    enableJblIntelligentChangeLine: false,
    enableJblWebsocketListening: false,
    enableLiveScoreMatchTracker: false,
    enableLiveScoreMatchTrackerExpanded: false,
    enableLoginChangeLine: false,
    enableExpandHightLightView: false,
    enableMarketLiquidityCache: false,
    enableMobileHightlightCompetitionView: false,
    enableNeuaAnalytics: false,
    enableNonIntegerStake: false,
    enableNoTxnIdle: false,
    enableOcerNavigation: false,
    enableQueryDataSubdomain: false,
    enableRacingWebsiteGreyhoundPlayLay: false,
    enableRacingWebsiteHorsePlayLay: false,
    enableReduceBetfairSizeFromFrontend: false,
    enableShowSportradarSportsbookForecast: false,
    enableShowGeniusSportsForecast: false,
    enableStreamingAkamai: false,
    enableStreamingAli: false,
    enableStreamingLimelight: false,
    enableStreamingPlayListV2: false,
    enableStreamingTencent: false,
    enableStreamingWangsu: false,
    enableStreamingEdgecast: false,
    enableStreamingCDNetwork: false,
    enableTermsConditionsPage: false,
    eventLabel: [],
    fancybetKhaddaMaxRuns: 0,
    fancybetKhaddaMinRuns: 0,
    fancybetKhaddaRunsMaxLength: 0,
    getFancyBetMarketsTaskCycleTime: null,
    groupSite: 0,
    hasAccount: false,
    isApp: false,
    isFake: false,
    isCheckBookMode: false,
    isDemoBtnShow: false,
    isEnableAcceptAnyOdds: false,
    isEnableBookMaker: false,
    isEnableElectionFancyBet: false,
    isEnableMobileReportPage: false,
    isEnableFancyBet: false,
    isEnableGameHall: false,
    isEnableLowLiquidity: false,
    isEnableMiniGameEntrance: false,
    isEnableMobileWebSocket: false,
    isEnablePlayerNeedLogin: false,
    isEnableSportsBookBet: false,
    isEnableGeniusSportsBet: false,
    isEnableYuviEntrance: false,
    isEnterFairGroup: false,
    isFancyFairGroup: false,
    isFromApi: false,
    isFromWeb: false,
    isHideUpcomingHorseRace: false,
    isIOS: false,
    isMobileAppActive: false,
    isMobileNavigation: false,
    isMobileOrTablet: false,
    isOfferGeniusSports: false,
    isOfferSportradarSportsBook: false,
    isPromotionPlaying: false,
    isRacingWebSite: false,
    isShowBetfairIcon: false,
    isShowPromoBanner: false,
    isShowVirtualCricket: false,
    isSkyInplayGroup: false,
    isTempRole: false,
    isUseWebSocket: false,
    isValidationCodeEnable: false,
    isViewedAnnouncement: false,
    jblChannelId: "",
    jblHashCode: "",
    lowLiquidityForMatchOdds: 0,
    lowLiquidityForOthers: 0,
    marketLiquiditys: {},
    minBet: 1,
    mobileDownloadUrl: "",
    mobileVersion: "",
    mobileSize: "",
    mobileData: "",
    oddsMinBetMap: {},
    playerCurrency: 0,
    playerCurrencyType: "",
    popupAnnouncementKeys: {
      desktopImgUrl: "",
      desktopMessage: "",
      mobileImgUrl: "",
      mobileMessage: ""
    },
    promoBanner: [],
    qD: [],
    queryPass: "",
    redirectDomain: "",
    soccerMenuOrderMap: [],
    supportInfo: {
      customer: [],
      email: [],
      facebook: [],
      instagram: [],
      telegram: [],
      twitter: [],
      whatsapp: []
    },
    taxRatio: 0,
    tempCtrlQueryDataOneSeconds: true,
    tempCtrlUseWebsocketBetfair: false,
    tempCtrlUseWebsocketBookmaker: false,
    tempCtrlUseWebsocketFancybet: false,
    userCoin: 0,
    userID: "",
    valid: "",
    webSiteCssName: "",
    webSiteDescription: "",
    webSiteDisplayName: "",
    webSiteGroupId: 0,
    webSiteType: 0
  })

  const updateValid = (valid: string) => {
    state.valid = valid
  }

  const updateWebsiteErrorStatus = (
    errorStatus: "SystemMaintenance" | "IPBlock" | null,
    errorMessage = ""
  ) => {
    websiteErrorStatus.value = errorStatus
    websiteErrorMessage.value = errorMessage
  }

  const reloadRouterAlive = () => {
    isRouterAlive.value = false
    nextTick(() => {
      isRouterAlive.value = true
    })
  }

  const updateInitInfo = (info: QueryInItInfoResponse) => {
    Object.assign(state, {
      ...state,
      ...info
    })
  }

  const updateIsViewedAnnouncement = (val: boolean) => {
    state.isViewedAnnouncement = val
  }

  const updateIsApp = (isApp: boolean) => {
    state.isApp = isApp
  }

  const loginPollingFrequency = computed(() =>
    state.tempCtrlQueryDataOneSeconds ? 1000 : 500
  )

  const formatLines = (lines: string[] = []): string[] => {
    const stringLines = lines
    if (!stringLines) return []

    const lineArr = lines
      .map(line => {
        try {
          return window.atob(line).toLowerCase()
        } catch (error) {
          console.error("Error decoding Base64 string:", error)
          return null
        }
      })
      .filter(line => line !== null)

    return [...new Set(lineArr)]
  }

  const defaultChangeLines = computed(() => formatLines(state.dC))

  const loginedChangeLines = computed(() => formatLines(state.qD))

  const lines = computed(() =>
    state.userID && !state.isTempRole
      ? loginedChangeLines.value
      : defaultChangeLines.value
  )

  // `replaceAll` is polyfilled for Chrome < 85 (see @/plugins/polyfills). The
  // String() wrap guards against non-string mobileData the API occasionally
  // returns, which would otherwise lack the method.
  const mobileVersionLabel = computed(() => {
    const { mobileVersion, mobileSize, mobileData } = state
    const safeData = String(mobileData ?? "").replaceAll("-", "/")
    return `v${mobileVersion} - ${safeData} - ${mobileSize}`
  })

  const updateAccountPage = (accountPage: AccountPage) => {
    state.accountPage = accountPage
  }

  const updateIsTempRole = (isTempRole: boolean) => {
    state.isTempRole = isTempRole
  }

  return {
    state,
    isRouterAlive,
    websiteErrorStatus,
    websiteErrorMessage,
    loginPollingFrequency,
    defaultChangeLines,
    loginedChangeLines,
    lines,
    mobileVersionLabel,
    reloadRouterAlive,
    updateValid,
    updateInitInfo,
    updateWebsiteErrorStatus,
    updateIsViewedAnnouncement,
    updateAccountPage,
    updateIsTempRole,
    updateIsApp
  }
})

export default useWebsiteInfoStore
